import React from 'react'
import style from './articles.style'

const DSCreatecustreports = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Создание кастомных отчетов в&nbsp;Google Analytics </h2>
      <p>
        Несмотря на&nbsp;огромное количество стандартных отчетов, сервис
        веб-аналитики Google Analytics позволяет создавать собственные отчеты
        и&nbsp;сводки с&nbsp;наборами данных под ваши нужны.
      </p>
      <p>
        Немного терминологии Google Analytics. Кастомные отчеты в&nbsp;Google
        Analytics называются “Специальными отчетами”. Согласно{' '}
        <a href="https://www.google.com/url?q=https://support.google.com/analytics/answer/1151300?hl%3Dru&sa=D&ust=1558095553677000">
          Google Support
        </a>
        &nbsp;“Специальный отчет&nbsp;– это отчет, который вы настроили сами. Вы
        выбираете показатели и&nbsp;параметры и&nbsp;решаете, в&nbsp;каком виде
        они должны быть представлены”.
      </p>
      <p>Итак, как же сделать кастомный отчет в&nbsp;Google Analytics.</p>
      <p>
        Читайте также: &lt;5 полезных кастомных отчетов в&nbsp;Google
        Analytics&gt; (ссылка на&nbsp;статью)
      </p>
      <h3>Где искать “Специальные отчеты” </h3>
      <p>
        Перейдите: “Специальные отчеты”&nbsp;→ “Мои отчеты”&nbsp;→ “Добавить
        отчет”.
      </p>
      <div style={{ width: 200 }}>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/ni08ws.png" alt="true" />
          {/* <figcaption>-</figcaption> */}
        </figure>
      </div>

      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni08ws&amp;sa=D&amp;ust=1558095553678000">http://prntscr.com/ni08ws</a></p> */}
      <p>
        Если вы все сделали правильно, то попадете на&nbsp;страницу конструктора
        отчетов.
      </p>

      <figure className={classes.helpArticleFigure}>
        <img src="/images/ni09ju.png" alt="true" />
        <figcaption>Страница конструктора отчета</figcaption>
      </figure>

      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni09ju&amp;sa=D&amp;ust=1558095553679000">http://prntscr.com/ni09ju</a> (подпись: Страница конструктора отчета)</p> */}
      <h3>Из чего состоит конструктор отчетов </h3>
      <p>В “Общей информации” введите название будущего отчета.</p>
      <p>
        В “Структуре отчета” находятся настройки основных полей будущего
        кастомного отчета, а&nbsp;именно:
      </p>
      <h4>1. Название </h4>
      <p>
        Здесь отмечается название конкретной вкладки отчета, так как вкладок
        может быть несколько.
      </p>
      <h4>2. Тип </h4>
      <p>Отчет может быть трех типов:</p>
      <ul>
        <li>
          “Анализ” позволяет изменять отчет дополнительными параметрами
          и&nbsp;фильтровать данные, в&nbsp;том же окне накладывает данные
          на&nbsp;графики. Похож на&nbsp;стандартный отчет Google Analytics.
        </li>
      </ul>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/ni0c7v.png" alt="true" />
        <figcaption>ип отчета “Анализ”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni0c7v&amp;sa=D&amp;ust=1558095553680000">http://prntscr.com/ni0c7v</a> (подпись: Тип отчета “Анализ”)</p> */}
      <ul>
        <li>
          “Простая таблица” представляет собой таблицу указанных данных без
          дополнительных опций их изменения.
        </li>
      </ul>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/ni0czx.png" alt="true" />
        <figcaption>Тип отчета “Простая таблица”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni0czx&amp;sa=D&amp;ust=1558095553680000">http://prntscr.com/ni0czx</a> (подпись: Тип отчета “Простая таблица”)</p> */}
      <ul>
        <li>
          “Наложение данных на&nbsp;карту” позволяет собирать необходимые данные
          в&nbsp;разрезе геотаргетинга.
        </li>
      </ul>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/ni0edg.png" alt="true" />
        <figcaption>Типа отчета “Наложение данных”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni0edg&amp;sa=D&amp;ust=1558095553681000">http://prntscr.com/ni0edg</a> (подпись: Типа отчета “Наложение данных”)</p> */}
      <h4>3. Группы показателей и&nbsp;анализ параметров </h4>
      <p>Доступны во вкладках анализа и&nbsp;простых таблиц:</p>
      <ul>
        <li>
          Группы показателей&nbsp;– конкретные значения выбранных данных
          (например, количество пользователей, количество кликов с&nbsp;рекламы,
          количество транзакций и&nbsp;т.д.).
        </li>
        <li>
          Анализ параметров&nbsp;– данные, на&nbsp;основе которых будет
          проводиться анализ (например, данные необходимо разделить по
          источникам трафика).
        </li>
      </ul>
      <h4>4. Фильтры </h4>
      <p>
        Если необходимо проанализировать часть пользователей, в&nbsp;настройках
        отчетов есть фильтр. Можно рассмотреть несколько примеров:
      </p>
      <ul>
        <li>
          Фильтрация данных только по платному трафику. Так как весь платный
          трафик в&nbsp;нашем случае размечен как cpc (cost per click), cpm
          (cost per mille) и&nbsp;cpa (cost per action), выбирайте каналы,
          которые содержат метку “cp” (содержит, а&nbsp;не соответствует).
          в&nbsp;искомом отчете остаются только данные по указанному фильтру.
        </li>
      </ul>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/ni0p90.png" alt="true" />
        <figcaption>Выбираем каналы, содержащие cpc</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni0p90&amp;sa=D&amp;ust=1558095553682000">http://prntscr.com/ni0p90</a> (подпись: Выбираем каналы, содержащие cpc)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/ni0qj1.png" alt="true" />
        <figcaption>Итог</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni0qj1&amp;sa=D&amp;ust=1558095553682000">http://prntscr.com/ni0qj1</a> (подпись: Итог)</p> */}
      <ul>
        <li>
          Либо можно отфильтровать данные по параметру “Тип трафика”. Google
          Analytics распределяет весь трафик между своими стандартными типами,
          если удается его определить (распределение можно настроить
          самостоятельно): paid&nbsp;– платный трафик с&nbsp;рекламных кампаний;
          referral&nbsp;– трафик с&nbsp;ссылок на&nbsp;сторонних сайтах
          (например ссылка в&nbsp;статье); organic&nbsp;– трафик из органической
          выдачи поисковых систем; direct&nbsp;– прямой трафик; email&nbsp;–
          трафик из писем электронной почты, рассылок; display&nbsp;– рекламные
          предложения, размещенные в&nbsp;виде визуальной графической информации
          на&nbsp;площадке, баннера (не тизеры Рекламной сети Яндекса
          и&nbsp;Контекстно медийной сети Google Ads с&nbsp;оплатой за клик).
        </li>
      </ul>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/ni0xbg.png" alt="true" />
        <figcaption>Пример отчета с&nbsp;фильтром</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni0xbg&amp;sa=D&amp;ust=1558095553683000">http://prntscr.com/ni0xbg</a> (подпись: Пример отчета с&nbsp;фильтром)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/ni0zcz.png" alt="true" />
        <figcaption>Пример фильтра</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/ni0zcz&amp;sa=D&amp;ust=1558095553683000">http://prntscr.com/ni0zcz</a> (подпись: Пример фильтра)</p> */}
      <h4>5. Представления </h4>
      <p>
        В данном поле нужно выбрать представление, на&nbsp;основе которого
        формируется специальный отчет. Если у вас нет дополнительных
        представлений, то выбираете единственный стандартный "Все данные по веб
        сайту". Если вы используете дополнительные представления
        с&nbsp;фильтрацией или импортом данных, учитывайте это при создании
        специального отчета. Например, для отчета с&nbsp;данными по стоимости
        кликов и&nbsp;окупаемости инвестиций нужно выбрать представление,
        в&nbsp;которое совершается импорт этих данных.
      </p>
      <h3>Как могут выглядеть ваши отчеты </h3>
      <h4>1. Воронка продаж по типам трафика </h4>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/niqijc.png" alt="true" />
        <figcaption>Пример отчета</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/niqijc&amp;sa=D&amp;ust=1558095553685000">http://prntscr.com/niqijc</a> (подпись: Пример отчета)</p> */}
      <p>
        Этот отчет помогает понять, что из ваших активностей в&nbsp;вебе
        приносит вам больше продаж: seo оптимизация и&nbsp;работа над контентом;
        платный трафик; smm или что-то еще. Для простоты анализа отчет не
        содержит детальных данных по конкретным источникам или рекламным
        кампаниям.
      </p>
      <h4>2. Воронка продаж по платному трафику </h4>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir3ii.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “По источнику”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir3ii&amp;sa=D&amp;ust=1558095553686000">http://prntscr.com/nir3ii</a> (подпись: Пример отчета. Вкладка “По источнику”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir3ve.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “По кампаниям”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir3ve&amp;sa=D&amp;ust=1558095553686000">http://prntscr.com/nir3ve</a> (подпись: Пример отчета. Вкладка “По кампаниям”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir4kp.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Канал/кампания”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir4kp&amp;sa=D&amp;ust=1558095553687000">http://prntscr.com/nir4kp</a> (подпись: Пример отчета. Вкладка “Канал/кампания”)</p> */}
      <p>
        Поймите, какие платные каналы трафика приносят вам больше продаж. Для
        простоты анализа отчет состоит из 3 вкладок с&nbsp;разной степенью
        глубины данных.
      </p>
      <h4>3. Воронка продаж по поисковому трафику </h4>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nitliu.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Поисковые системы”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nitliu&amp;sa=D&amp;ust=1558095553688000">http://prntscr.com/nitliu</a> (подпись: Пример отчета. Вкладка “Поисковые системы”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nitlpo.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Поисковые запросы”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nitlpo&amp;sa=D&amp;ust=1558095553688000">http://prntscr.com/nitlpo</a> (подпись: Пример отчета. Вкладка “Поисковые запросы”)</p> */}
      <p>
        Отслеживайте эффективность отдельных поисковых систем и&nbsp;поисковых
        запросом (из за шифрования запросов поисковыми системами данные могут
        быть с&nbsp;большой погрешностью). с&nbsp;помощью ROMI center, можно
        вручную учитывать расходы на&nbsp;SEO специалиста, копирайтера
        и&nbsp;т.д. Это позволит приблизиться к&nbsp;полноценной сквозной
        аналитике и&nbsp;с большим пониманием распределять бюджет
        на&nbsp;улучшение SEO показателей сайта.
      </p>
      <h4>4. Отчет для корректировок ставок по гео </h4>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlabym.png" alt="true" />
        <figcaption>Пример отчета</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlabym&amp;sa=D&amp;ust=1558095553689000">http://prntscr.com/nlabym</a> (подпись: Пример отчета)</p> */}
      <p>
        Поможет вам правильно указывать корректировки ставок по географии
        в&nbsp;ваших рекламных кампаниях (если вы показываете рекламу
        на&nbsp;несколько городов).
      </p>
      <h4>5. Отчет для корректировок ставок </h4>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlajcn.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Устройства”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlajcn&amp;sa=D&amp;ust=1558095553690000">http://prntscr.com/nlajcn</a> (подпись: Пример отчета. Вкладка “Устройства”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlaji0.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Время суток”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlaji0&amp;sa=D&amp;ust=1558095553690000">http://prntscr.com/nlaji0</a> (подпись: Пример отчета. Вкладка “Время суток”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlajmx.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “День недели”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlajmx&amp;sa=D&amp;ust=1558095553691000">http://prntscr.com/nlajmx</a> (подпись: Пример отчета. Вкладка “День недели”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlajt6.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “День месяца”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlajt6&amp;sa=D&amp;ust=1558095553691000">http://prntscr.com/nlajt6</a> (подпись: Пример отчета. Вкладка “День месяца”)</p> */}
      <p>
        Поможет вам правильно указывать корректировки ставок (по устройствам,
        времени клика) в&nbsp;ваших рекламных кампаниях.
      </p>
      <p>
        Как сделать такие отчеты самостоятельно, читайте &lt;здесь&gt; (ссылка
        на&nbsp;статью 5 полезных кастомных отчетов в&nbsp;Google Analytics)
      </p>
    </article>
  )
}

export default style(DSCreatecustreports)
